import React, { Component } from 'react';
import PropTypes from 'prop-types';
import get from 'lodash/get';
import FCLink from '../fc_link/fc_link';
import { trackGAEvent } from '../../../client/utils/third_party_trackers/ga';
import withTracking from '../../../utils/tracking/components/withTracking';
import { defaultClick } from '../../../utils/tracking/events/pageEvents';
import EventModel from '../../../utils/tracking/models';

/**
 *
 * @param props
 * @returns {Component}
 * @constructor
 */

class MainMenu extends Component {
  constructor() {
    super();

    this.setMenuClasses = this.setMenuClasses.bind(this);
    this.openSection = this.openSection.bind(this);
    this.clickSiteCollectionItem = this.clickSiteCollectionItem.bind(this);

    this.state = {
      active: null,
      events_active: false
    };
  }

  setMenuClasses(visible) {
    const classNames = ['main-menu'];

    if (visible) {
      classNames.push('main-menu--opened');
    }

    return classNames.join(' ');
  }

  openSection(section) {
    if (section === this.state.active) {
      this.setState({ active: null });
    } else {
      this.setState({ active: section });
    }
  }

  openSectionMenuHeight(data) {
    let totalheight;

    if (data.title === 'collections') {
      const list = document.querySelector(
        '.main-menu__collections-content--collections'
      ).childNodes;
      let collectionsHeight = 0;
      for (let i = 0; i < get(list, 'length'); i += 1) {
        collectionsHeight += list[i].offsetHeight;
      }
      totalheight = collectionsHeight;
    } else if (data.title === 'fastco works') {
      const list = document.querySelector(
        '.main-menu__collections-content--fastcoworks'
      ).childNodes;
      let collectionsHeight = 0;
      for (let i = 0; i < get(list, 'length'); i += 1) {
        collectionsHeight += list[i].offsetHeight;
      }
      totalheight = collectionsHeight;
    } else {
      this.navItemHeight = document.querySelector(
        '.main-menu__collection'
      ).offsetHeight;

      totalheight = this.navItemHeight * data.collectionItems;
    }

    return totalheight;
  }

  clickSiteCollectionItem(title, index) {
    // [DataLayer] trigger nav item click event
    const clickEvent = new EventModel(
      'Left Menu Item Click',
      `menu${title}`,
      'leftMenu',
      `leftmenu ${title}`,
      index + 2 // accomodate for hardcoded Homepage item
    );
    this.props.trackClick(clickEvent.getTrackingObject());

    trackGAEvent({
      eventCategory: 'Interaction',
      eventAction: 'Burger Nav Category',
      eventLabel: title
    });

    this.props.closeMenu();
  }

  renderSectionContent(data) {
    if (!data) {
      return null;
    }

    const listLink = data.content.map(info => {
      const { url, title, deck = '', external = false } = info;

      /* eslint-disable jsx-a11y/no-noninteractive-element-interactions */
      return (
        <li
          key={title}
          className="main-menu__collection"
          onClick={() => this.clickSiteCollectionItem(title)}
        >
          <FCLink
            to={url}
            title={title}
            config={data.config}
            externalLink={external}
          >
            <h3 className="main-menu__collection-title">{title}</h3>
            {get(deck, 'length') > 0 ? (
              <p className="main-menu__collection-deck">{deck}</p>
            ) : (
              ''
            )}
          </FCLink>
        </li>
      );
    });

    return listLink;
  }

  render() {
    const {
      social,
      currentIssueCover,
      magazineLink,
      mainMenuVisible,
      collections,
      fastcoworks,
      scaled,
      config,
      topics
    } = this.props;
    const { subscribeLink } = this.props;
    const socialLinks = social[get(config, 'site', '')] || [];

    return (
      <div
        className={this.setMenuClasses(mainMenuVisible, scaled)}
        onClick={e => e.stopPropagation()}
      >
        <div
          className={`main-menu__brand ${
            scaled ? 'main-menu__brand--scaled' : ''
          }`}
        >
          <button className="icon-close" onClick={this.props.closeMenu} />
        </div>

        <ul className="main-menu__collections-content main-menu__collections-content--menu">
          <li className="main-menu__collection">
            <FCLink to="/" title="Homepage" config={config}>
              <h3 className="main-menu__collection-title">Homepage</h3>
            </FCLink>
          </li>
          {topics.map((topic, index) => (
            <li
              key={topic.title}
              className="main-menu__collection"
              onClick={() => this.clickSiteCollectionItem(topic.title, index)}
            >
              <FCLink
                to={topic.url}
                title={topic.title}
                config={config}
                externalLink={topic.external}
              >
                <h3 className="main-menu__collection-title">{topic.title}</h3>
              </FCLink>
            </li>
          ))}
        </ul>
        <a
          href="https://fastcompany.zendesk.com/hc/en-us"
          className="main-menu__helpcenter"
        >
          Help Center
        </a>

        {fastcoworks.map((collection, index) => {
          const { title, sections } = collection;
          const content = sections;
          const collectionsList = title === 'fastco works';
          const collectionItems = get(content, 'length');
          return (
            <div
              key={collection.className}
              className="main-menu__dropdown-content"
            >
              <a
                className={`${collection.className} ${
                  this.state.active === collection.title
                    ? `${collection.className}--active`
                    : ''
                }`}
                onClick={this.openSection.bind(null, collection.title)}
              >
                {/* eslint-enable jsx-a11y/anchor-is-valid, react/jsx-no-bind */}

                <span className="main-menu__collections-title">
                  {collection.title}
                </span>
                <span
                  className={`main-menu__collections-caret ${
                    this.state.active === collection.title
                      ? 'main-menu__collections-caret--active'
                      : ''
                  }`}
                />
              </a>
              <ul
                className={`main-menu__collections-content ${
                  collectionsList
                    ? 'main-menu__collections-content--fastcoworks'
                    : ''
                } ${
                  this.state.active === collection.title
                    ? 'main-menu__collections-content--active'
                    : ''
                } `}
                style={{
                  height:
                    this.state.active === collection.title
                      ? this.openSectionMenuHeight({ collectionItems, title })
                      : 0
                }}
              >
                {this.renderSectionContent({ content, index, config })}
              </ul>
            </div>
          );
        })}

        {collections.map((collection, index) => {
          const { title, sections } = collection;
          const content = sections;
          const collectionsList = title === 'collections';
          const collectionItems = get(content, 'length');

          return (
            <div
              key={collection.className}
              className="main-menu__dropdown-content"
            >
              <a
                className={`${collection.className} ${
                  this.state.active === collection.title
                    ? `${collection.className}--active`
                    : ''
                }`}
                onClick={this.openSection.bind(null, collection.title)}
              >
                {/* eslint-enable jsx-a11y/anchor-is-valid, react/jsx-no-bind */}

                <span className="main-menu__collections-title">
                  {collection.title}
                </span>
                <span
                  className={`main-menu__collections-caret ${
                    this.state.active === collection.title
                      ? 'main-menu__collections-caret--active'
                      : ''
                  }`}
                />
              </a>
              <ul
                className={`main-menu__collections-content ${
                  collectionsList
                    ? 'main-menu__collections-content--collections'
                    : ''
                } ${
                  this.state.active === collection.title
                    ? 'main-menu__collections-content--active'
                    : ''
                } `}
                style={{
                  height:
                    this.state.active === collection.title
                      ? this.openSectionMenuHeight({ collectionItems, title })
                      : 0
                }}
              >
                {this.renderSectionContent({ content, index, config })}
              </ul>
            </div>
          );
        })}

        <a
          href="https://www.fastcompany.com/newsletters"
          className="main-menu__newsletters"
          onClick={() => {
            trackGAEvent({
              eventCategory: 'Burger',
              eventAction: 'Nav Item',
              eventLabel: 'Newsletters'
            });
          }}
        >
          Newsletter
        </a>

        <div className="main-menu__dropdown-content">
          <a
            className={
              this.state.events_active
                ? 'main-menu__collections main-menu__collections--active'
                : 'main-menu__collections'
            }
            onClick={() => {
              this.setState({
                events_active: !this.state.events_active
              });
            }}
          >
            {/* eslint-enable jsx-a11y/anchor-is-valid, react/jsx-no-bind */}

            <span className="main-menu__collections-title">Events</span>
            <span
              className={`main-menu__collections-caret ${
                this.state.events_active
                  ? 'main-menu__collections-caret--active'
                  : ''
              }`}
            />
          </a>
          <ul
            className={`main-menu__collections-content main-menu__collections-content--collections
            ${
              this.state.events_active
                ? 'main-menu__collections-content--active'
                : ''
            } `}
            style={{
              height: this.state.events_active ? '116px' : 0
            }}
          >
            <li className="main-menu__collection">
              <a href="https://events.festival.fastcompany.com/">
                <h3 className="main-menu__events-link">Innovation Festival</h3>
              </a>
              <a href="https://events.fastcompany.com/fcgrill/">
                <h3 className="main-menu__events-link">The Grill</h3>
              </a>
            </li>
          </ul>
        </div>

        <a
          href="https://catalog.mindedge.com/fastcompany"
          className="main-menu__learning"
        >
          Courses and Learning
        </a>

        <a
          href="https://images.fastcompany.net/image/upload/v1572457392/fcweb/Mediakit_2019_10.17.19_alrvfp.pdf"
          target="_blank"
          rel="noopener noreferrer"
          className="main-menu__advertise"
        >
          Advertise
        </a>

        <a href={magazineLink} className="main-menu__current-issue">
          Current Issue
        </a>

        <div className="main-menu__subscription">
          <a
            href={magazineLink}
            className="main-menu__mag-cover"
            style={{ backgroundImage: `url(${currentIssueCover})` }}
          >
            Current Issue
          </a>
          <div className="main-menu__subscription-button-row">
            <a
              href={subscribeLink}
              className="main-menu__subscribe-link"
              title="subscribe"
            >
              SUBSCRIBE
            </a>
          </div>
        </div>

        <div className="main-menu__social-menu">
          <div className="main-menu__social-text">
            <span className="main-menu__social-text-hed">Follow us:</span>
          </div>

          <div className="main-menu__social-list">
            {socialLinks
              .filter(({ image_menu: menu }) => !!menu)
              .map(network => (
                <a
                  key={network.url}
                  href={network.url}
                  className={`main-menu__social-button main-menu__social-button--${
                    network.property
                  }`}
                  target="_blank"
                  rel="noopener noreferrer"
                  onClick={() => {
                    trackGAEvent({
                      eventCategory: 'Social',
                      eventAction: 'Nav Follow Us',
                      eventLabel: network.property
                    });
                  }}
                >
                  <img src={network.image_menu} alt="Social media icons" />
                </a>
              ))}
          </div>
        </div>
      </div>
    );
  }
}

MainMenu.defaultProps = {
  mainMenuVisible: false,
  scaled: false,
  trackClick: () => false
};

MainMenu.propTypes = {
  social: PropTypes.shape({}).isRequired,
  collections: PropTypes.arrayOf(
    PropTypes.shape({
      title: PropTypes.string.isRequired,
      url: PropTypes.string,
      deck: PropTypes.string
    })
  ).isRequired,
  fastcoworks: PropTypes.arrayOf(
    PropTypes.shape({
      title: PropTypes.string.isRequired,
      url: PropTypes.string,
      deck: PropTypes.string
    })
  ).isRequired,
  currentIssueCover: PropTypes.string.isRequired,
  magazineLink: PropTypes.string.isRequired,
  subscribeLink: PropTypes.string.isRequired,
  mainMenuVisible: PropTypes.bool,
  trackClick: PropTypes.func,
  closeMenu: PropTypes.func.isRequired,
  scaled: PropTypes.bool,
  config: PropTypes.shape({}).isRequired,
  topics: PropTypes.arrayOf(PropTypes.shape({})).isRequired
};

const mapTrackingToProps = trackEvent => ({
  trackClick: pageObject => trackEvent(defaultClick(pageObject))
});

const trackedMainMenu = withTracking(mapTrackingToProps)(MainMenu);

export default trackedMainMenu;
